import { Box, DialogContent, DialogTitle, List, ListItem, ListItemIcon, ListItemText, Stack, TextField, Typography } from "@mui/material";
import { ULine, UMargin, URow, USection } from "../common/ui.page";
import { CBackButton, CBackToMain } from "../components/cr.ui.buttons";
import { CPage, CPageTop, CSection } from "../components/cr.ui.page";
import { useOrder } from "../components/order";
import { UNIT_CATEGORIES, UNIT_XP_PERC, useUnit } from "../components/unit";
import { GREY, INFO_COLOR, MAIN_COLOR, MAIN_COLOR_ACTIVE, SECONDARY_COLOR, WARN_COLOR, WHITE } from "../style/theme";
import { UButton } from "../common/ui.buttons";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { AddBattleTraitButton, AddRelicButton, AddWeaponModificationButton, CUnitCompText, CUnitEditComposition, CUnitEditUnitModelButton, CUnitEditUnitUpgradesButton, CUnitGrade, CUnitKwywordEditor, DataBar, ExtUnitSection, ExtUnitStats } from "../components/cr.ui.unit";
import { UIcon } from "../common/ui.icon";
import { UEditableTextField } from "../common/ui.editable";
import { PageContext } from "../common/pages";
import { useContext, useState } from "react";
import { CPayButton, CPayButtonDisplay, RP_COLOR } from "../components/cr.ui.requisition";
import { UDialgoCloseIcon, UDialog, UDialogCloseOnCompleteButton } from "../common/ui.dialog";
import { gradient } from "../common/ui.gradient";
import { CEditComposition } from "../components/cr.ui.composition";
import { UnitEdit, useUnitEdit } from "../components/unit.edit";
import { useExt } from "../components/ext";


export function PageUnit(props) {
    const order = useOrder()
    const unit = useUnit()
    const hasHonours = unit.unspentHonours > 0;
    const gainedHonours = unit.honours - unit.unspentHonours;

    if (hasHonours) {
        return <CPage>
            <CBackToMain codex={order.codex.name} />

            <USection sx={{ paddingBottom: 2 }}>
                <UnitTitle showXp={false} />
            </USection>
            <Stack spacing={1}>
                <HonourSelection />
                {gainedHonours > 0 && <CSection>
                    <EpicGears />
                </CSection>}
            </Stack>
            <USection>
                <UnitKeywords />
            </USection>

            <USection sx={{ paddingTop: 10 }}>
                <UnitCtrl />
            </USection>
        </CPage>
    }

    return <CPage>
        <CBackToMain codex={order.codex.name} />

        <USection sx={{ paddingY: 2 }}>
            <UnitTitle showXp={unit.gainXp && !unit.isNew} />
        </USection>

        {!unit.isNew && <USection sx={{ paddingBottom: 4 }}>
            <UnitStats />
        </USection>}

        <RestoreSection />

        <Stack spacing={1}>
            {unit.honours > 0 && <CSection>
                <EpicGears />
            </CSection>}
            {unit.scars.length > 0 && <CSection>
                <UnitScars />
            </CSection>}

            <UnitEnhancements />

            <ExtUnitSection />
            <VeteranPayButton />

            {unit.viewEquipments && <USection>
                <UnitComposition sx={{ fontSize: 12 }} />
            </USection>}
            <USection>
                <UnitKeywords />
            </USection>

            <USection sx={{ paddingTop: 10 }}>
                <UnitCtrl />
            </USection>
        </Stack>

    </CPage>
}

function UnitScars() {
    const unit = useUnit()

    return <Stack spacing={2}>
        <Typography sx={{ color: GREY[800] }}>
            Ferite di Guerra
        </Typography>
        <List sx={{ padding: 0 }}>
            {unit.scars.map(w => <>
                <ListItem key={w.id}>
                    <ListItemIcon>
                        <UIcon name="scar" size={24} />
                    </ListItemIcon>
                    <ListItemText primary={w.name} secondary={w.description} />
                </ListItem>
                <CPayButton onComplete={unit.reload} unitId={unit.id} type={'scar.remove'} params={[w.id]} />
            </>)}
        </List>
    </Stack>
}

function EpicGears() {
    const unit = useUnit()

    return <Stack spacing={2}>
        {unit.relics && unit.relics.length > 0 && <>
            <Typography sx={{ fontWeight: 600, color: '#F4C92F' }}>
                Reliquie Crociate
            </Typography>
            <List sx={{ padding: 0 }}>
                {unit.relics.map(w => <ListItem key={w.id}>
                    <ListItemIcon>
                        <UIcon name="honour" size={24} />
                    </ListItemIcon>
                    <ListItemText primary={w.name} secondary={w.description} />
                </ListItem>)}
            </List>
        </>}
        {unit.weaponModifications.length > 0 && <>
            <Typography sx={{ color: GREY[700] }}>
                Armi modificate
            </Typography>
            <List sx={{ padding: 0 }}>
                {unit.weaponModifications.map(w => <ListItem key={w.id}>
                    <ListItemIcon>
                        <UIcon name="honour" size={24} />
                    </ListItemIcon>
                    <Stack>
                        <Typography sx={{ color: RP_COLOR, lineHeight: 1 }}>
                            {w.weapon}
                        </Typography>
                        <Stack sx={{ flex: 1 }}>
                            {w.modifications.map(m => <ListItemText key={m.id} primary={m.name} secondary={m.description} />)}
                        </Stack>

                    </Stack>
                </ListItem>)}
            </List>
        </>}
        {unit.traits.length > 0 && <>
            <Typography sx={{ color: GREY[700] }}>
                Tratti di Battaglia
            </Typography>
            <List sx={{ padding: 0 }}>
                {unit.traits.map(w => <ListItem key={w.id}>
                    <ListItemIcon>
                        <UIcon name="honour" size={24} />
                    </ListItemIcon>
                    <ListItemText primary={w.name} secondary={w.description} />
                </ListItem>)}
            </List>
        </>}
    </Stack>
}

function HonourSelection() {
    const unit = useUnit()

    return <CSection>
        <Stack sx={{ padding: 1, textAlign: 'center' }} alignItems="center" spacing={2}>
            <UIcon name="honour" size={48} />
            <Stack>
                <Typography sx={{ fontWeight: 600, color: '#F4C92F' }}>
                    Onore di Battaglia
                </Typography>
                <Typography sx={{ fontSize: 12, color: GREY[800] }}>
                    Scegli un miglioramento da dare a questa unità
                </Typography>
            </Stack>
            <AddTraitButton />
            <AddWeaponUpgradeButton />
            <AddRelicsButton />
        </Stack>
    </CSection>
}

function AddTraitButton() {
    const unit = useUnit()
    const ext = useExt()
    return <AddBattleTraitButton
        cmd={ext.battleTraitCall(unit.id)}
        name="Tratto di Battaglia"
        desc={'Aggiungi un Tratto di Battaglia'} />
}

function AddWeaponUpgradeButton() {
    const unit = useUnit()
    return <AddWeaponModificationButton
        cmd={"unit/" + unit.id + "/wmod/new"}
        name="Arma modificata"
        desc={"Modifica una delle armi"} />
}

function AddRelicsButton() {
    const unit = useUnit()
    const ext = useExt()
    if (unit.maxRelics == 0 || unit.maxRelics <= unit.relics.length) {
        return <></>
    }
    return <AddRelicButton
        cmd={ext.relicsCall(unit.id)}
        name="Reliquia Crociata"
        desc={'Aggiungi una Reliquia Crociata'} />
}

function UnitTitle(props) {
    const { showXp } = props;
    const unit = useUnit()
    return <>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Stack sx={{ paddingY: 1 }}>
                <Typography sx={{ lineHeight: 1, fontSize: 12, color: GREY[800] }}>{unit.name ? unit.unitType : ''}</Typography>
                <UEditableTextField
                    onComplete={unit.reload}
                    restCommit={"unit/" + unit.id + '/edit/name'}
                    sx={{ lineHeight: 1.5 }}
                    defValue={unit.unitType}
                    value={unit.name} />
            </Stack>
            {!unit.isNew && <CUnitGrade grade={unit.isEpic ? 'epic' : unit.grade} />}
        </Stack>
        {showXp && <UMargin>
            <Box sx={{ background: GREY[100] }}>
                <Box sx={{
                    background: MAIN_COLOR_ACTIVE,
                    height: 4,
                    width: UNIT_XP_PERC(unit.xp) + '%'
                }}></Box>
            </Box>
        </UMargin>}
        <UEditableTextField multiline restCommit={"unit/" + unit.id + '/edit/description'}
            sx={{ color: GREY[800], fontSize: 12, paddingBottom: 2, whiteSpace: 'pre-wrap' }}
            defValue={'Racconta la storia di questa unità, le sue origini, la sua lore e come si è distinta in battaglia durante la tua campagna!'}
            onComplete={unit.reload}
            value={unit.description} />
        <URow sx={{ paddingX: 2, }}>
            <Typography sx={{ fontSize: 12 }}>Costo in punti</Typography>
            <UEditableTextField
                type="number"
                sx={{ fontSize: 12, fontWeight: 600 }}
                onComplete={unit.reload}
                textFieldProps={{ sx: { maxWidth: 70 } }}
                value={unit.pts} restCommit={"unit/" + unit.id + '/edit/pts'} />
        </URow>
    </>
}

function RestoreSection() {
    const unit = useUnit()
    const xp = unit.maxRestoreXp;
    const mark = unit.maxRestoreMarked;
    const pendingRestore = xp + mark > 0;

    if (!pendingRestore) {
        return <></>
    }

    const style = gradient([MAIN_COLOR_ACTIVE, INFO_COLOR, MAIN_COLOR]);

    return <USection sx={{ paddingBottom: 4 }}>
        <Typography>
            Recupero esperienza
        </Typography>
        <Stack spacing={2}>

            {xp > 0 && <UButton
                call={'restore/unit/' + unit.id} payload={{ xp: 1 }}
                onComplete={unit.reload}
                sx={{ ...style }}
                variant="contained">Aggiungi +1XP</UButton>}

            {mark > 0 && <UButton
                call={'restore/unit/' + unit.id}
                payload={{ marked: 1 }}
                onComplete={unit.reload}
                sx={{ ...style }} variant="contained">Destinato alla grandezza aggiuntiva +3XP</UButton>}

        </Stack>
    </USection>
}

function UnitStats(props) {
    const unit = useUnit()

    return <Stack spacing={2}>
        {unit.gainXp && <DataBar name="Punti Esperienza" value={unit.xp} color={MAIN_COLOR_ACTIVE} />}
        {unit.gainXp && <DataBar name="Punti Crociata" value={unit.cp} color={MAIN_COLOR} />}
        {unit.played > 0 && <DataBar name="Uccisioni" value={unit.kills} color={MAIN_COLOR} />}
        <DataBar name="Partite giocate" value={unit.played} color={MAIN_COLOR} />
        {unit.played > 0 && <DataBar name="Partite sopravvissute" value={unit.played - unit.death} color={MAIN_COLOR} />}
        <ExtUnitStats />
    </Stack>
}

function UnitComposition(props) {
    const unit = useUnit()
    return <Stack>
        <CUnitCompText {...props} comp={unit.composition} />
        <CUnitEditUnitUpgradesButton onComplete={unit.reload} />
        <CUnitEditUnitModelButton onComplete={unit.reload} />
    </Stack>
}

function UnitKeywords(props) {
    const unit = useUnit()

    return <Stack>
        <Box sx={{ flex: 1 }}>
            {unit.categories.map(c => <Typography sx={{
                fontFamily: 'Verdana, sans-serif',
                fontSize: 10,
                color: GREY[800],
                display: 'inline-block',
                paddingX: 2,
            }} key={c}>{UNIT_CATEGORIES[c]}</Typography>)}
        </Box>
        <Box>  <CUnitKwywordEditor
            onComplete={unit.reload}
            button={<UButton>Modifica keywords</UButton>}
            keywords={unit.categories}
            call={'unit/' + unit.id + '/edit/categories'}
        />
        </Box>
    </Stack>
}

function UnitCtrl() {
    const unit = useUnit()
    const cmdPage = useContext(PageContext)

    return <Stack>
        <UButton
            onComplete={() => {
                unit.reload();
                cmdPage.setPage(' ')
            }}
            call={"unit/" + unit.id + "/remove"}
            confirm={"Rimuovere " + (unit.name || unit.unitType) + " dal tuo Ordine di Battaglia? Non sarà possibile recuperare l'esperienza guadagnata."}
            color="warning">Rimuovi dall'Ordine di Battaglia</UButton>
    </Stack>
}

function UnitEnhancements() {
    const unit = useUnit()

    if (!unit.viewEnhancements) {
        return <></>
    }

    const enh = unit.enhancements && unit.enhancements.length > 0 ? unit.enhancements[0] : null

    return <CSection>
        <Typography sx={{ color: GREY[700] }}>Miglioramento</Typography>
        {enh && <ListItem>
            <ListItemText primary={enh.name} secondary={enh.description} />
        </ListItem>}
        <Stack spacing={2}>
            {enh && <EnhancementPayButton type="enhancement.modify" />}
            {enh && <UButton
                confirm="Se rimuovi il miglioramento, il suo costo in PR non sarà rimborsato. Sei sicuro di volerlo rimuovere?"
                onClick={unit.removeEnhancement}
                color="warning">Rimuovi miglioramento</UButton>}
            {!enh && <EnhancementPayButton type="enhancement.add" />}
        </Stack>
    </CSection>
}

function EnhancementPayButton(props) {
    const unit = useUnit()
    const { type } = props;
    const [params, setParams] = useState(['', '', 0])
    const name = params[0]

    return <CPayButton onComplete={unit.reload} payProps={{ disabled: name < 3 }} unitId={unit.id} type={type} params={params}>
        <Stack spacing={4} sx={{ paddingTop: 4 }}>
            <TextField size="small" label="Nome" value={params[0]} onChange={e => setParams([e.target.value, params[1], params[2]])} />
            <TextField multiline size="small" label="Descrizione" value={params[1]} onChange={e => setParams([params[0], e.target.value, params[2]])} />
            <TextField type="number" size="small" label="Costo" value={params[2]} onChange={e => setParams([params[0], params[1], e.target.value])} />
        </Stack>
    </CPayButton>
}

function VeteranPayButton(props) {
    const unit = useUnit()

    if (unit.veteranReward) {
        return <USection>Unità Veterana Leggendaria</USection>
    }

    if (!unit.gainXp || unit.isChar || unit.xp < 30) {
        return <></>
    }

    return <CSection>
        <ListItemText
            primary="Unità veterana"
            secondary="Puoi continuare a guadagnare esperienza rendendo l'unità Veterana"
        />
        <CPayButton onComplete={unit.reload} unitId={unit.id} type={'veteran'} />
    </CSection>
}